import React from 'react';
import Card from '../components/common/Card';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto py-12 px-4 space-y-8">
        {/* Header */}
        <section className="text-center">
          <h1 className="text-xl sm:text-2xl font-bold text-emphasis mb-4">Cookie Policy</h1>
          <p className="text-secondary">How Salon Market uses cookies and similar technologies</p>
        </section>

        {/* Content */}
        <Card className="p-8">
          <div className="prose prose-sm max-w-none">
            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">1. What Are Cookies?</h2>
              <p className="text-secondary mb-3">
                Cookies are small text files stored on your device when you visit a website. We also use
                similar browser technologies such as local storage. Together they help the platform
                remember who you are and how you like to use it.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">2. Cookies We Use</h2>
              <h3 className="text-base font-bold text-emphasis mb-2">Essential (always on)</h3>
              <p className="text-secondary mb-3">
                These are required for the platform to function and cannot be switched off:
              </p>
              <ul className="list-disc list-inside text-secondary space-y-2 ml-4 mb-3">
                <li><strong>Session &amp; sign-in tokens</strong> — keep you logged in securely between pages and visits.</li>
                <li><strong>Security</strong> — protect against cross-site request forgery and abuse (e.g. rate limiting).</li>
                <li><strong>Preferences</strong> — remember settings such as saved drafts, favorites, and your cookie choice itself.</li>
              </ul>
              <h3 className="text-base font-bold text-emphasis mb-2">Optional (with your consent)</h3>
              <ul className="list-disc list-inside text-secondary space-y-2 ml-4 mb-3">
                <li><strong>Analytics</strong> — help us understand which features are used so we can improve the platform.</li>
              </ul>
              <h3 className="text-base font-bold text-emphasis mb-2">Third-party services</h3>
              <p className="text-secondary mb-3">
                Some features rely on trusted third parties that may set their own cookies when you use them:
                Google (sign-in with Google), Cloudinary (photo uploads), and MakyPay (payment processing on
                their hosted checkout pages). Their use of cookies is governed by their own policies.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">3. Your Choices</h2>
              <p className="text-secondary mb-3">
                When you first visit, we ask whether to allow optional cookies. Choosing
                <strong> "Essential only"</strong> limits us to what the platform needs to function.
                You can change your mind at any time by clearing this site's data in your browser —
                the consent banner will appear again on your next visit.
              </p>
              <p className="text-secondary mb-3">
                Most browsers also let you block or delete cookies entirely in their settings. Note that
                blocking essential cookies will prevent core features like signing in from working.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">4. Changes to This Policy</h2>
              <p className="text-secondary mb-3">
                We may update this Cookie Policy as the platform evolves. Material changes will be
                communicated through the website or other official channels before they take effect.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-emphasis mb-3">5. Contact</h2>
              <p className="text-secondary">
                Questions about this policy? Reach us through the Help Center or the contact options on
                the website.
              </p>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CookiePolicy;
